import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import SortableEntityTableRow, {
  SortableEntityTableRowProps,
} from 'components/SortableEntityTableRow';
import Link from '@mui/material/Link';
import TableCell from 'components/TableCell';

import { ServiceRow_service$key } from '__generated__/ServiceRow_service.graphql';

type Props = SortableEntityTableRowProps & {
  service: ServiceRow_service$key;
};

const types = {
  SOLO: 'Individualus',
  GROUP: 'Grupė',
};

const ServiceRow: FC<Props> = ({ service, ...props }) => {
  const serviceData = useFragment(
    graphql`
      fragment ServiceRow_service on Service {
        id
        name
        type
        price

        ...SortableEntityTableRow_entity
      }
    `,
    service
  );

  const { id, name, type, price } = serviceData;
  const displayPrice = price?.map(item => `€${item}`).join(' - ');

  return (
    <SortableEntityTableRow entity={serviceData} {...props}>
      <TableCell>
        <Link href={`/settings/services/${id}`}>{name}</Link>
      </TableCell>

      <TableCell center>{displayPrice}</TableCell>

      <TableCell center>{type && types[type]}</TableCell>
    </SortableEntityTableRow>
  );
};

export default ServiceRow;
